'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _common = require('../../common');

var _utils = require('../../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var formatMoney = _utils.FormattingUtils.formatMoney;

var MVAUnderwritingInsight = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(MVAUnderwritingInsight, _Component);

  function MVAUnderwritingInsight() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MVAUnderwritingInsight);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MVAUnderwritingInsight.__proto__ || Object.getPrototypeOf(MVAUnderwritingInsight)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'stateMVAThreshold', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MVAUnderwritingInsight, [{
    key: 'renderComparativeNegligence',
    value: function renderComparativeNegligence() {
      var comparative_negligence = this.props.stateMVAThreshold.comparative_negligence;

      switch (comparative_negligence) {
        case '1% Bar':
          return this.onePercentBarTemplate();
        case '50% Bar':
          return this.fiftyPercentBarTemplate();
        case '51% Bar':
          return this.fiftyOnePercentBarTemplate();
        case 'No Bar':
          return this.noBarTemplate();
        case '"Slight" Bar':
          return this.slightBarTemplate();
        case 'Not Specified':
          return null;
        default:
          return null;
      }
    }
  }, {
    key: 'renderPIPRestriction',
    value: function renderPIPRestriction() {
      var pip_suit_restrictions = this.props.stateMVAThreshold.pip_suit_restrictions;

      switch (pip_suit_restrictions) {
        case 'No Threshold':
          return this.noThresholdTemplate();
        case 'Certain Threshold':
          return this.certainThresholdTemplate();
        case 'No Fault':
          return this.noFaultThreshold();
        default:
          return null;
      }
    }
  }, {
    key: 'renderPIP',
    value: function renderPIP() {
      var pip_information = this.props.stateMVAThreshold.pip_information;

      switch (pip_information) {
        case 'No PIP':
          return this.noPIPTemplate();
        case 'Offered':
          return this.offeredPIPTemplate();
        case 'Mandatory':
          return this.mandatoryPIPTemplate();
        default:
          return null;
      }
    }
  }, {
    key: 'renderLiabilityData',
    value: function renderLiabilityData() {
      var _props$stateMVAThresh = this.props.stateMVAThreshold,
          per_accident_liability_limit = _props$stateMVAThresh.per_accident_liability_limit,
          per_person_liability_limit = _props$stateMVAThresh.per_person_liability_limit,
          state = _props$stateMVAThresh.state;


      if (state === 'FL') {
        return _react2.default.createElement(
          'p',
          null,
          'Bodily Injury Liability (BI) coverage is not required to legally drive an automobile in the state of',
          ' ',
          _react2.default.createElement(
            'strong',
            null,
            state
          ),
          '.'
        );
      }

      return _react2.default.createElement(
        'p',
        null,
        'The minimum insurance policy required by law in ',
        _react2.default.createElement(
          'strong',
          null,
          state
        ),
        ' is',
        ' ',
        _react2.default.createElement(
          'strong',
          null,
          formatMoney(per_person_liability_limit),
          '/',
          formatMoney(per_accident_liability_limit)
        ),
        ' ',
        'and many legal funders rely on this number absent actual knowledge of policy limits.'
      );
    }
  }, {
    key: 'renderStacking',
    value: function renderStacking() {
      var stateMVAThreshold = this.props.stateMVAThreshold;

      if (stateMVAThreshold.stacking) {
        return;
      }
      return _react2.default.createElement(
        'span',
        null,
        'If the plaintiff has access to UM/UIM coverage, it ',
        _react2.default.createElement(
          'strong',
          null,
          'cannot be stacked'
        ),
        ' on the tortfeasor\'s policy.'
      );
    }
  }, {
    key: 'renderResourceURL',
    value: function renderResourceURL() {
      var stateMVAThreshold = this.props.stateMVAThreshold;

      return _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'a',
          { target: '_blank', href: stateMVAThreshold.resource_website },
          'View External Resource'
        )
      );
    }
  }, {
    key: 'noPIPTemplate',
    value: function noPIPTemplate() {
      return _react2.default.createElement(
        'p',
        null,
        'There is ',
        _react2.default.createElement(
          'strong',
          null,
          'no PIP'
        ),
        ' in this state.'
      );
    }
  }, {
    key: 'offeredPIPTemplate',
    value: function offeredPIPTemplate() {
      return _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'strong',
          null,
          'PIP is offered'
        ),
        ' to motorists in this ',
        this.getPIPCoverage()
      );
    }
  }, {
    key: 'mandatoryPIPTemplate',
    value: function mandatoryPIPTemplate() {
      return _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'strong',
          null,
          'PIP is mandatory'
        ),
        ' in this ',
        this.getPIPCoverage()
      );
    }
  }, {
    key: 'renderUMInformation',
    value: function renderUMInformation() {
      var _props$stateMVAThresh2 = this.props.stateMVAThreshold,
          uninsured_motorist_information = _props$stateMVAThresh2.uninsured_motorist_information,
          state = _props$stateMVAThresh2.state,
          uim_per_person_coverage = _props$stateMVAThresh2.uim_per_person_coverage,
          uim_per_accident_coverage = _props$stateMVAThresh2.uim_per_accident_coverage;

      if (uninsured_motorist_information === 'Not Required') {
        return _react2.default.createElement(
          'p',
          null,
          'UM/UIM is ',
          _react2.default.createElement(
            'strong',
            null,
            'not required'
          ),
          '. ',
          this.renderStacking()
        );
      } else if (uninsured_motorist_information === 'UM') {
        return _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            state
          ),
          ' requires ',
          _react2.default.createElement(
            'strong',
            null,
            formatMoney(uim_per_person_coverage),
            '/',
            formatMoney(uim_per_accident_coverage)
          ),
          ' in UM coverage.',
          this.renderStacking()
        );
      }
      return _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'strong',
          null,
          state
        ),
        ' requires ',
        _react2.default.createElement(
          'strong',
          null,
          formatMoney(uim_per_person_coverage),
          '/',
          formatMoney(uim_per_accident_coverage)
        ),
        ' in UM/UIM coverage.',
        this.renderStacking()
      );
    }
  }, {
    key: 'getPIPCoverage',
    value: function getPIPCoverage() {
      var stateMVAThreshold = this.props.stateMVAThreshold,
          pip_per_person_coverage = stateMVAThreshold.pip_per_person_coverage,
          pip_per_accident_coverage = stateMVAThreshold.pip_per_accident_coverage,
          pip_limited_by = stateMVAThreshold.pip_limited_by,
          unlimited_pip_coverage = stateMVAThreshold.unlimited_pip_coverage;

      if (pip_per_person_coverage && pip_per_accident_coverage) {
        return _react2.default.createElement(
          'span',
          null,
          'state and provides up to ',
          _react2.default.createElement(
            'strong',
            null,
            formatMoney(pip_per_person_coverage)
          ),
          ' per person,',
          ' ',
          _react2.default.createElement(
            'strong',
            null,
            formatMoney(pip_per_accident_coverage)
          ),
          ' per accident in medical coverage.'
        );
      } else if (pip_per_person_coverage) {
        if (pip_limited_by) {
          return _react2.default.createElement(
            'span',
            null,
            'state and provides up to ',
            _react2.default.createElement(
              'strong',
              null,
              formatMoney(pip_per_person_coverage)
            ),
            ' in medical coverage ',
            pip_limited_by,
            '.'
          );
        }
        return _react2.default.createElement(
          'span',
          null,
          'state and provides up to ',
          _react2.default.createElement(
            'strong',
            null,
            formatMoney(pip_per_person_coverage)
          ),
          ' in medical coverage.'
        );
      } else if (unlimited_pip_coverage) {
        return 'state and provides unlimited coverage.';
      }
      return 'state.';
    }
  }, {
    key: 'onePercentBarTemplate',
    value: function onePercentBarTemplate() {
      var stateMVAThreshold = this.props.stateMVAThreshold;

      return _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'strong',
          null,
          stateMVAThreshold.state
        ),
        ' uses a ',
        _react2.default.createElement(
          'strong',
          null,
          '1% Bar'
        ),
        '. If the injured party carries any fault (even 1%), he or she will be barred from any recovery.'
      );
    }
  }, {
    key: 'fiftyPercentBarTemplate',
    value: function fiftyPercentBarTemplate() {
      var stateMVAThreshold = this.props.stateMVAThreshold;

      return _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'strong',
          null,
          stateMVAThreshold.state
        ),
        ' uses a ',
        _react2.default.createElement(
          'strong',
          null,
          '50% Bar'
        ),
        '. Recovery is only possible if',
        ' ',
        'the injured party is less than 50% at fault. Recovery will be proportionately reduced by the degree to',
        ' ',
        'which he or she is liable.'
      );
    }
  }, {
    key: 'fiftyOnePercentBarTemplate',
    value: function fiftyOnePercentBarTemplate() {
      var stateMVAThreshold = this.props.stateMVAThreshold;

      return _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'strong',
          null,
          stateMVAThreshold.state
        ),
        ' is a ',
        _react2.default.createElement(
          'strong',
          null,
          '51% Bar'
        ),
        ' state. Recovery is only possible',
        ' ',
        'if the injured party is less than 51% at fault. Recovery will be proportionately reduced by the degree to',
        ' ',
        'which he or she is liable.'
      );
    }
  }, {
    key: 'noBarTemplate',
    value: function noBarTemplate() {
      var stateMVAThreshold = this.props.stateMVAThreshold;

      return _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'strong',
          null,
          stateMVAThreshold.state
        ),
        ' uses a ',
        _react2.default.createElement(
          'strong',
          null,
          'Pure Comparative Fault'
        ),
        ' system. If the',
        ' ',
        'injured party is partially at fault (even 99%), recovery is still possible. Recovery will be',
        ' ',
        'proportionately reduced by the degree that the claimant is deemed liable.'
      );
    }
  }, {
    key: 'slightBarTemplate',
    value: function slightBarTemplate() {
      var stateMVAThreshold = this.props.stateMVAThreshold;

      return _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'strong',
          null,
          stateMVAThreshold.state
        ),
        ' uses a "Slight" Bar. If the injured party\'s',
        ' ',
        'negligence is more than "slight" in comparison to the other party\'s, he or she will be',
        ' ',
        'barred from any recovery'
      );
    }
  }, {
    key: 'noThresholdTemplate',
    value: function noThresholdTemplate() {
      return _react2.default.createElement(
        'p',
        null,
        'If an individual recovers through PIP, there is ',
        _react2.default.createElement(
          'strong',
          null,
          'no threshold'
        ),
        ' on filing a damages claim against the tortfeasor.'
      );
    }
  }, {
    key: 'certainThresholdTemplate',
    value: function certainThresholdTemplate() {
      return _react2.default.createElement(
        'p',
        null,
        'In this state an individual is not permitted to file a tort action unless his or her damages reach a certain threshold.'
      );
    }
  }, {
    key: 'noFaultThreshold',
    value: function noFaultThreshold() {
      return _react2.default.createElement(
        'p',
        null,
        'This is a ',
        _react2.default.createElement(
          'strong',
          null,
          'No-Fault'
        ),
        ' state, but there is ',
        _react2.default.createElement(
          'strong',
          null,
          'no threshold'
        ),
        ' on filing a damages claim against the tortfeasor.'
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Row2.default,
        null,
        _react2.default.createElement(
          _common.InfoWell.Label,
          null,
          'MVA UNDERWRITING INSIGHT'
        ),
        _react2.default.createElement(
          _common.InfoWell.Value,
          null,
          this.renderComparativeNegligence(),
          this.renderLiabilityData(),
          this.renderUMInformation(),
          this.renderPIP(),
          this.renderPIPRestriction(),
          this.renderResourceURL()
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return MVAUnderwritingInsight;
}(_react.Component), _class3.propTypes = {
  stateMVAThreshold: _propTypes2.default.object
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'stateMVAThreshold', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
})), _class2)) || _class) || _class;

var _default = MVAUnderwritingInsight;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(formatMoney, 'formatMoney', '/app/src/components/page-case/main-underwriting/MVAUnderwritingInsight.js');
  reactHotLoader.register(MVAUnderwritingInsight, 'MVAUnderwritingInsight', '/app/src/components/page-case/main-underwriting/MVAUnderwritingInsight.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-underwriting/MVAUnderwritingInsight.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2UtY2FzZS9tYWluLXVuZGVyd3JpdGluZy9NVkFVbmRlcndyaXRpbmdJbnNpZ2h0LmpzIl0sIm5hbWVzIjpbImZvcm1hdE1vbmV5IiwiRm9ybWF0dGluZ1V0aWxzIiwiTVZBVW5kZXJ3cml0aW5nSW5zaWdodCIsImF1dG9CaW5kTWV0aG9kcyIsIm9ic2VydmVyIiwiY29tcGFyYXRpdmVfbmVnbGlnZW5jZSIsInByb3BzIiwic3RhdGVNVkFUaHJlc2hvbGQiLCJvbmVQZXJjZW50QmFyVGVtcGxhdGUiLCJmaWZ0eVBlcmNlbnRCYXJUZW1wbGF0ZSIsImZpZnR5T25lUGVyY2VudEJhclRlbXBsYXRlIiwibm9CYXJUZW1wbGF0ZSIsInNsaWdodEJhclRlbXBsYXRlIiwicGlwX3N1aXRfcmVzdHJpY3Rpb25zIiwibm9UaHJlc2hvbGRUZW1wbGF0ZSIsImNlcnRhaW5UaHJlc2hvbGRUZW1wbGF0ZSIsIm5vRmF1bHRUaHJlc2hvbGQiLCJwaXBfaW5mb3JtYXRpb24iLCJub1BJUFRlbXBsYXRlIiwib2ZmZXJlZFBJUFRlbXBsYXRlIiwibWFuZGF0b3J5UElQVGVtcGxhdGUiLCJwZXJfYWNjaWRlbnRfbGlhYmlsaXR5X2xpbWl0IiwicGVyX3BlcnNvbl9saWFiaWxpdHlfbGltaXQiLCJzdGF0ZSIsInN0YWNraW5nIiwicmVzb3VyY2Vfd2Vic2l0ZSIsImdldFBJUENvdmVyYWdlIiwidW5pbnN1cmVkX21vdG9yaXN0X2luZm9ybWF0aW9uIiwidWltX3Blcl9wZXJzb25fY292ZXJhZ2UiLCJ1aW1fcGVyX2FjY2lkZW50X2NvdmVyYWdlIiwicmVuZGVyU3RhY2tpbmciLCJwaXBfcGVyX3BlcnNvbl9jb3ZlcmFnZSIsInBpcF9wZXJfYWNjaWRlbnRfY292ZXJhZ2UiLCJwaXBfbGltaXRlZF9ieSIsInVubGltaXRlZF9waXBfY292ZXJhZ2UiLCJyZW5kZXJDb21wYXJhdGl2ZU5lZ2xpZ2VuY2UiLCJyZW5kZXJMaWFiaWxpdHlEYXRhIiwicmVuZGVyVU1JbmZvcm1hdGlvbiIsInJlbmRlclBJUCIsInJlbmRlclBJUFJlc3RyaWN0aW9uIiwicmVuZGVyUmVzb3VyY2VVUkwiLCJDb21wb25lbnQiLCJwcm9wVHlwZXMiLCJQcm9wVHlwZXMiLCJvYmplY3QiLCJvYnNlcnZhYmxlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOztBQUNBOztBQUNBOzs7Ozs7OztBQUlBOztBQUVBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQUtFQSxXLEdBQ0VDLHNCLENBREZELFc7O0lBS0lFLHNCLE9BRkxDLGdDLGVBQ0FDLG1COzs7Ozs7Ozs7Ozs7Ozs7Ozs7O2tEQUlnQztBQUFBLFVBQ3JCQyxzQkFEcUIsR0FDTSxLQUFLQyxLQUFMLENBQVdDLGlCQURqQixDQUNyQkYsc0JBRHFCOztBQUU3QixjQUFRQSxzQkFBUjtBQUNFLGFBQUssUUFBTDtBQUFlLGlCQUFPLEtBQUtHLHFCQUFMLEVBQVA7QUFDZixhQUFLLFNBQUw7QUFBZ0IsaUJBQU8sS0FBS0MsdUJBQUwsRUFBUDtBQUNoQixhQUFLLFNBQUw7QUFBZ0IsaUJBQU8sS0FBS0MsMEJBQUwsRUFBUDtBQUNoQixhQUFLLFFBQUw7QUFBZSxpQkFBTyxLQUFLQyxhQUFMLEVBQVA7QUFDZixhQUFLLGNBQUw7QUFBcUIsaUJBQU8sS0FBS0MsaUJBQUwsRUFBUDtBQUNyQixhQUFLLGVBQUw7QUFBc0IsaUJBQU8sSUFBUDtBQUN0QjtBQUFTLGlCQUFPLElBQVA7QUFQWDtBQVNEOzs7MkNBRXVCO0FBQUEsVUFDZEMscUJBRGMsR0FDWSxLQUFLUCxLQUFMLENBQVdDLGlCQUR2QixDQUNkTSxxQkFEYzs7QUFFdEIsY0FBUUEscUJBQVI7QUFDRSxhQUFLLGNBQUw7QUFBcUIsaUJBQU8sS0FBS0MsbUJBQUwsRUFBUDtBQUNyQixhQUFLLG1CQUFMO0FBQTBCLGlCQUFPLEtBQUtDLHdCQUFMLEVBQVA7QUFDMUIsYUFBSyxVQUFMO0FBQWlCLGlCQUFPLEtBQUtDLGdCQUFMLEVBQVA7QUFDakI7QUFBUyxpQkFBTyxJQUFQO0FBSlg7QUFNRDs7O2dDQUVZO0FBQUEsVUFDSEMsZUFERyxHQUNpQixLQUFLWCxLQUFMLENBQVdDLGlCQUQ1QixDQUNIVSxlQURHOztBQUVYLGNBQVFBLGVBQVI7QUFDRSxhQUFLLFFBQUw7QUFBZSxpQkFBTyxLQUFLQyxhQUFMLEVBQVA7QUFDZixhQUFLLFNBQUw7QUFBZ0IsaUJBQU8sS0FBS0Msa0JBQUwsRUFBUDtBQUNoQixhQUFLLFdBQUw7QUFBa0IsaUJBQU8sS0FBS0Msb0JBQUwsRUFBUDtBQUNsQjtBQUFTLGlCQUFPLElBQVA7QUFKWDtBQU1EOzs7MENBRXNCO0FBQUEsa0NBT2pCLEtBQUtkLEtBUFksQ0FFbkJDLGlCQUZtQjtBQUFBLFVBR2pCYyw0QkFIaUIseUJBR2pCQSw0QkFIaUI7QUFBQSxVQUlqQkMsMEJBSmlCLHlCQUlqQkEsMEJBSmlCO0FBQUEsVUFLakJDLEtBTGlCLHlCQUtqQkEsS0FMaUI7OztBQVVyQixVQUFJQSxVQUFVLElBQWQsRUFBb0I7QUFDbEIsZUFDRTtBQUFBO0FBQUE7QUFBQTtBQUVHLGFBRkg7QUFFTztBQUFBO0FBQUE7QUFBU0E7QUFBVCxXQUZQO0FBQUE7QUFBQSxTQURGO0FBTUQ7O0FBRUQsYUFDRTtBQUFBO0FBQUE7QUFBQTtBQUNrRDtBQUFBO0FBQUE7QUFBU0E7QUFBVCxTQURsRDtBQUFBO0FBRUcsV0FGSDtBQUVPO0FBQUE7QUFBQTtBQUFTdkIsc0JBQVlzQiwwQkFBWixDQUFUO0FBQUE7QUFBbUR0QixzQkFBWXFCLDRCQUFaO0FBQW5ELFNBRlA7QUFHRyxXQUhIO0FBQUE7QUFBQSxPQURGO0FBTUQ7OztxQ0FFaUI7QUFBQSxVQUNSZCxpQkFEUSxHQUNjLEtBQUtELEtBRG5CLENBQ1JDLGlCQURROztBQUVoQixVQUFJQSxrQkFBa0JpQixRQUF0QixFQUFnQztBQUM5QjtBQUNEO0FBQ0QsYUFDRTtBQUFBO0FBQUE7QUFBQTtBQUF5RDtBQUFBO0FBQUE7QUFBQTtBQUFBLFNBQXpEO0FBQUE7QUFBQSxPQURGO0FBR0Q7Ozt3Q0FFb0I7QUFBQSxVQUNYakIsaUJBRFcsR0FDVyxLQUFLRCxLQURoQixDQUNYQyxpQkFEVzs7QUFFbkIsYUFDRTtBQUFBO0FBQUE7QUFBRztBQUFBO0FBQUEsWUFBRyxRQUFPLFFBQVYsRUFBbUIsTUFBTUEsa0JBQWtCa0IsZ0JBQTNDO0FBQUE7QUFBQTtBQUFILE9BREY7QUFHRDs7O29DQUVnQjtBQUNmLGFBQ0U7QUFBQTtBQUFBO0FBQUE7QUFBWTtBQUFBO0FBQUE7QUFBQTtBQUFBLFNBQVo7QUFBQTtBQUFBLE9BREY7QUFHRDs7O3lDQUVxQjtBQUNwQixhQUNFO0FBQUE7QUFBQTtBQUFHO0FBQUE7QUFBQTtBQUFBO0FBQUEsU0FBSDtBQUFBO0FBQXlELGFBQUtDLGNBQUw7QUFBekQsT0FERjtBQUdEOzs7MkNBRXVCO0FBQ3RCLGFBQ0U7QUFBQTtBQUFBO0FBQUc7QUFBQTtBQUFBO0FBQUE7QUFBQSxTQUFIO0FBQUE7QUFBOEMsYUFBS0EsY0FBTDtBQUE5QyxPQURGO0FBR0Q7OzswQ0FFc0I7QUFBQSxtQ0FDaUYsS0FBS3BCLEtBQUwsQ0FBV0MsaUJBRDVGO0FBQUEsVUFDYm9CLDhCQURhLDBCQUNiQSw4QkFEYTtBQUFBLFVBQ21CSixLQURuQiwwQkFDbUJBLEtBRG5CO0FBQUEsVUFDMEJLLHVCQUQxQiwwQkFDMEJBLHVCQUQxQjtBQUFBLFVBQ21EQyx5QkFEbkQsMEJBQ21EQSx5QkFEbkQ7O0FBRXJCLFVBQUlGLG1DQUFtQyxjQUF2QyxFQUF1RDtBQUNyRCxlQUNFO0FBQUE7QUFBQTtBQUFBO0FBQWE7QUFBQTtBQUFBO0FBQUE7QUFBQSxXQUFiO0FBQUE7QUFBNkMsZUFBS0csY0FBTDtBQUE3QyxTQURGO0FBR0QsT0FKRCxNQUtLLElBQUlILG1DQUFtQyxJQUF2QyxFQUE2QztBQUNoRCxlQUNFO0FBQUE7QUFBQTtBQUFHO0FBQUE7QUFBQTtBQUFTSjtBQUFULFdBQUg7QUFBQTtBQUFxQztBQUFBO0FBQUE7QUFBU3ZCLHdCQUFZNEIsdUJBQVosQ0FBVDtBQUFBO0FBQWdENUIsd0JBQVk2Qix5QkFBWjtBQUFoRCxXQUFyQztBQUFBO0FBQXNKLGVBQUtDLGNBQUw7QUFBdEosU0FERjtBQUdEO0FBQ0QsYUFDRTtBQUFBO0FBQUE7QUFBRztBQUFBO0FBQUE7QUFBU1A7QUFBVCxTQUFIO0FBQUE7QUFBcUM7QUFBQTtBQUFBO0FBQVN2QixzQkFBWTRCLHVCQUFaLENBQVQ7QUFBQTtBQUFnRDVCLHNCQUFZNkIseUJBQVo7QUFBaEQsU0FBckM7QUFBQTtBQUEwSixhQUFLQyxjQUFMO0FBQTFKLE9BREY7QUFHRDs7O3FDQUdpQjtBQUNWLFVBQUV2QixpQkFBRixHQUF3QixLQUFLRCxLQUE3QixDQUFFQyxpQkFBRjtBQUFBLFVBQ0F3Qix1QkFEQSxHQUMrRnhCLGlCQUQvRixDQUNBd0IsdUJBREE7QUFBQSxVQUN5QkMseUJBRHpCLEdBQytGekIsaUJBRC9GLENBQ3lCeUIseUJBRHpCO0FBQUEsVUFDb0RDLGNBRHBELEdBQytGMUIsaUJBRC9GLENBQ29EMEIsY0FEcEQ7QUFBQSxVQUNvRUMsc0JBRHBFLEdBQytGM0IsaUJBRC9GLENBQ29FMkIsc0JBRHBFOztBQUVOLFVBQUlILDJCQUEyQkMseUJBQS9CLEVBQTBEO0FBQ3hELGVBQ0U7QUFBQTtBQUFBO0FBQUE7QUFDMkI7QUFBQTtBQUFBO0FBQVNoQyx3QkFBWStCLHVCQUFaO0FBQVQsV0FEM0I7QUFBQTtBQUVHLGFBRkg7QUFFTztBQUFBO0FBQUE7QUFBUy9CLHdCQUFZZ0MseUJBQVo7QUFBVCxXQUZQO0FBQUE7QUFBQSxTQURGO0FBS0QsT0FORCxNQU9LLElBQUlELHVCQUFKLEVBQTZCO0FBQ2hDLFlBQUlFLGNBQUosRUFBb0I7QUFDbEIsaUJBQ0U7QUFBQTtBQUFBO0FBQUE7QUFBK0I7QUFBQTtBQUFBO0FBQVNqQywwQkFBWStCLHVCQUFaO0FBQVQsYUFBL0I7QUFBQTtBQUE0R0UsMEJBQTVHO0FBQUE7QUFBQSxXQURGO0FBR0Q7QUFDRCxlQUNFO0FBQUE7QUFBQTtBQUFBO0FBQStCO0FBQUE7QUFBQTtBQUFTakMsd0JBQVkrQix1QkFBWjtBQUFULFdBQS9CO0FBQUE7QUFBQSxTQURGO0FBR0QsT0FUSSxNQVVBLElBQUlHLHNCQUFKLEVBQTRCO0FBQy9CLGVBQ0Usd0NBREY7QUFHRDtBQUNELGFBQ0UsUUFERjtBQUdEOzs7NENBR3dCO0FBQUEsVUFDZjNCLGlCQURlLEdBQ08sS0FBS0QsS0FEWixDQUNmQyxpQkFEZTs7QUFFdkIsYUFDRTtBQUFBO0FBQUE7QUFBRztBQUFBO0FBQUE7QUFBU0EsNEJBQWtCZ0I7QUFBM0IsU0FBSDtBQUFBO0FBQXFEO0FBQUE7QUFBQTtBQUFBO0FBQUEsU0FBckQ7QUFBQTtBQUFBLE9BREY7QUFHRDs7OzhDQUUwQjtBQUFBLFVBQ2pCaEIsaUJBRGlCLEdBQ0ssS0FBS0QsS0FEVixDQUNqQkMsaUJBRGlCOztBQUV6QixhQUNFO0FBQUE7QUFBQTtBQUNFO0FBQUE7QUFBQTtBQUFTQSw0QkFBa0JnQjtBQUEzQixTQURGO0FBQUE7QUFDb0Q7QUFBQTtBQUFBO0FBQUE7QUFBQSxTQURwRDtBQUFBO0FBRUcsV0FGSDtBQUFBO0FBR0csV0FISDtBQUFBO0FBQUEsT0FERjtBQU9EOzs7aURBRTZCO0FBQUEsVUFDcEJoQixpQkFEb0IsR0FDRSxLQUFLRCxLQURQLENBQ3BCQyxpQkFEb0I7O0FBRTVCLGFBQ0U7QUFBQTtBQUFBO0FBQ0U7QUFBQTtBQUFBO0FBQVNBLDRCQUFrQmdCO0FBQTNCLFNBREY7QUFBQTtBQUNrRDtBQUFBO0FBQUE7QUFBQTtBQUFBLFNBRGxEO0FBQUE7QUFFRyxXQUZIO0FBQUE7QUFHRyxXQUhIO0FBQUE7QUFBQSxPQURGO0FBT0Q7OztvQ0FFZ0I7QUFBQSxVQUNQaEIsaUJBRE8sR0FDZSxLQUFLRCxLQURwQixDQUNQQyxpQkFETzs7QUFFZixhQUNFO0FBQUE7QUFBQTtBQUNFO0FBQUE7QUFBQTtBQUFTQSw0QkFBa0JnQjtBQUEzQixTQURGO0FBQUE7QUFDb0Q7QUFBQTtBQUFBO0FBQUE7QUFBQSxTQURwRDtBQUFBO0FBRUcsV0FGSDtBQUFBO0FBR0csV0FISDtBQUFBO0FBQUEsT0FERjtBQU9EOzs7d0NBRW9CO0FBQUEsVUFDWGhCLGlCQURXLEdBQ1csS0FBS0QsS0FEaEIsQ0FDWEMsaUJBRFc7O0FBRW5CLGFBQ0U7QUFBQTtBQUFBO0FBQ0U7QUFBQTtBQUFBO0FBQVNBLDRCQUFrQmdCO0FBQTNCLFNBREY7QUFBQTtBQUVHLFdBRkg7QUFBQTtBQUdHLFdBSEg7QUFBQTtBQUFBLE9BREY7QUFPRDs7OzBDQUVzQjtBQUNyQixhQUNFO0FBQUE7QUFBQTtBQUFBO0FBQW1EO0FBQUE7QUFBQTtBQUFBO0FBQUEsU0FBbkQ7QUFBQTtBQUFBLE9BREY7QUFHRDs7OytDQUUyQjtBQUMxQixhQUNFO0FBQUE7QUFBQTtBQUFBO0FBQUEsT0FERjtBQUdEOzs7dUNBRW1CO0FBQ2xCLGFBQ0U7QUFBQTtBQUFBO0FBQUE7QUFBYTtBQUFBO0FBQUE7QUFBQTtBQUFBLFNBQWI7QUFBQTtBQUEyRDtBQUFBO0FBQUE7QUFBQTtBQUFBLFNBQTNEO0FBQUE7QUFBQSxPQURGO0FBR0Q7Ozs2QkFFUztBQUNSLGFBQ0U7QUFBQyxxQkFBRDtBQUFBO0FBQ0U7QUFBQywwQkFBRCxDQUFVLEtBQVY7QUFBQTtBQUFBO0FBQUEsU0FERjtBQUVFO0FBQUMsMEJBQUQsQ0FBVSxLQUFWO0FBQUE7QUFDRyxlQUFLWSwyQkFBTCxFQURIO0FBRUcsZUFBS0MsbUJBQUwsRUFGSDtBQUdHLGVBQUtDLG1CQUFMLEVBSEg7QUFJRyxlQUFLQyxTQUFMLEVBSkg7QUFLRyxlQUFLQyxvQkFBTCxFQUxIO0FBTUcsZUFBS0MsaUJBQUw7QUFOSDtBQUZGLE9BREY7QUFhRDs7Ozs7Ozs7Ozs7RUF0T2tDQyxnQixXQXdPNUJDLFMsR0FBWTtBQUNqQm5DLHFCQUFtQm9DLG9CQUFVQztBQURaLEMsNkZBdk9sQkMsZ0I7OztXQUErQixFOzs7O2VBNE9uQjNDLHNCOzs7Ozs7Ozs7OzswQkFsUGJGLFc7MEJBS0lFLHNCIiwiZmlsZSI6Ik1WQVVuZGVyd3JpdGluZ0luc2lnaHQuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBDb21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IHsgb2JzZXJ2YWJsZSB9IGZyb20gJ21vYngnO1xuaW1wb3J0IHsgb2JzZXJ2ZXIgfSBmcm9tICdtb2J4LXJlYWN0JztcbmltcG9ydCBhdXRvQmluZE1ldGhvZHMgZnJvbSAnY2xhc3MtYXV0b2JpbmQtZGVjb3JhdG9yJztcblxuaW1wb3J0IHsgUm93IH0gZnJvbSAncmVhY3QtYm9vdHN0cmFwJztcblxuaW1wb3J0IHsgSW5mb1dlbGwgfSBmcm9tICcuLi8uLi9jb21tb24nO1xuXG5pbXBvcnQge1xuICBGb3JtYXR0aW5nVXRpbHMsXG59IGZyb20gJy4uLy4uLy4uL3V0aWxzJztcblxuY29uc3Qge1xuICBmb3JtYXRNb25leSxcbn0gPSBGb3JtYXR0aW5nVXRpbHM7XG5cbkBhdXRvQmluZE1ldGhvZHNcbkBvYnNlcnZlclxuY2xhc3MgTVZBVW5kZXJ3cml0aW5nSW5zaWdodCBleHRlbmRzIENvbXBvbmVudCB7XG4gIEBvYnNlcnZhYmxlIHN0YXRlTVZBVGhyZXNob2xkID0ge307XG5cbiAgcmVuZGVyQ29tcGFyYXRpdmVOZWdsaWdlbmNlICgpIHtcbiAgICBjb25zdCB7IGNvbXBhcmF0aXZlX25lZ2xpZ2VuY2UgfSA9IHRoaXMucHJvcHMuc3RhdGVNVkFUaHJlc2hvbGQ7XG4gICAgc3dpdGNoIChjb21wYXJhdGl2ZV9uZWdsaWdlbmNlKSB7XG4gICAgICBjYXNlICcxJSBCYXInOiByZXR1cm4gdGhpcy5vbmVQZXJjZW50QmFyVGVtcGxhdGUoKTtcbiAgICAgIGNhc2UgJzUwJSBCYXInOiByZXR1cm4gdGhpcy5maWZ0eVBlcmNlbnRCYXJUZW1wbGF0ZSgpO1xuICAgICAgY2FzZSAnNTElIEJhcic6IHJldHVybiB0aGlzLmZpZnR5T25lUGVyY2VudEJhclRlbXBsYXRlKCk7XG4gICAgICBjYXNlICdObyBCYXInOiByZXR1cm4gdGhpcy5ub0JhclRlbXBsYXRlKCk7XG4gICAgICBjYXNlICdcIlNsaWdodFwiIEJhcic6IHJldHVybiB0aGlzLnNsaWdodEJhclRlbXBsYXRlKCk7XG4gICAgICBjYXNlICdOb3QgU3BlY2lmaWVkJzogcmV0dXJuIG51bGw7XG4gICAgICBkZWZhdWx0OiByZXR1cm4gbnVsbDtcbiAgICB9XG4gIH1cblxuICByZW5kZXJQSVBSZXN0cmljdGlvbiAoKSB7XG4gICAgY29uc3QgeyBwaXBfc3VpdF9yZXN0cmljdGlvbnMgfSA9IHRoaXMucHJvcHMuc3RhdGVNVkFUaHJlc2hvbGQ7XG4gICAgc3dpdGNoIChwaXBfc3VpdF9yZXN0cmljdGlvbnMpIHtcbiAgICAgIGNhc2UgJ05vIFRocmVzaG9sZCc6IHJldHVybiB0aGlzLm5vVGhyZXNob2xkVGVtcGxhdGUoKTtcbiAgICAgIGNhc2UgJ0NlcnRhaW4gVGhyZXNob2xkJzogcmV0dXJuIHRoaXMuY2VydGFpblRocmVzaG9sZFRlbXBsYXRlKCk7XG4gICAgICBjYXNlICdObyBGYXVsdCc6IHJldHVybiB0aGlzLm5vRmF1bHRUaHJlc2hvbGQoKTtcbiAgICAgIGRlZmF1bHQ6IHJldHVybiBudWxsO1xuICAgIH1cbiAgfVxuXG4gIHJlbmRlclBJUCAoKSB7XG4gICAgY29uc3QgeyBwaXBfaW5mb3JtYXRpb24gfSA9IHRoaXMucHJvcHMuc3RhdGVNVkFUaHJlc2hvbGQ7XG4gICAgc3dpdGNoIChwaXBfaW5mb3JtYXRpb24pIHtcbiAgICAgIGNhc2UgJ05vIFBJUCc6IHJldHVybiB0aGlzLm5vUElQVGVtcGxhdGUoKTtcbiAgICAgIGNhc2UgJ09mZmVyZWQnOiByZXR1cm4gdGhpcy5vZmZlcmVkUElQVGVtcGxhdGUoKTtcbiAgICAgIGNhc2UgJ01hbmRhdG9yeSc6IHJldHVybiB0aGlzLm1hbmRhdG9yeVBJUFRlbXBsYXRlKCk7XG4gICAgICBkZWZhdWx0OiByZXR1cm4gbnVsbDtcbiAgICB9XG4gIH1cblxuICByZW5kZXJMaWFiaWxpdHlEYXRhICgpIHtcbiAgICBjb25zdCB7XG4gICAgICBzdGF0ZU1WQVRocmVzaG9sZDoge1xuICAgICAgICBwZXJfYWNjaWRlbnRfbGlhYmlsaXR5X2xpbWl0LFxuICAgICAgICBwZXJfcGVyc29uX2xpYWJpbGl0eV9saW1pdCxcbiAgICAgICAgc3RhdGUsXG4gICAgICB9LFxuICAgIH0gPSB0aGlzLnByb3BzO1xuXG5cbiAgICBpZiAoc3RhdGUgPT09ICdGTCcpIHtcbiAgICAgIHJldHVybiAoXG4gICAgICAgIDxwPlxuICAgICAgICAgIEJvZGlseSBJbmp1cnkgTGlhYmlsaXR5IChCSSkgY292ZXJhZ2UgaXMgbm90IHJlcXVpcmVkIHRvIGxlZ2FsbHkgZHJpdmUgYW4gYXV0b21vYmlsZSBpbiB0aGUgc3RhdGUgb2ZcbiAgICAgICAgICB7JyAnfTxzdHJvbmc+e3N0YXRlfTwvc3Ryb25nPi5cbiAgICAgICAgPC9wPlxuICAgICAgKTtcbiAgICB9XG5cbiAgICByZXR1cm4gKFxuICAgICAgPHA+XG4gICAgICAgIFRoZSBtaW5pbXVtIGluc3VyYW5jZSBwb2xpY3kgcmVxdWlyZWQgYnkgbGF3IGluIDxzdHJvbmc+e3N0YXRlfTwvc3Ryb25nPiBpc1xuICAgICAgICB7JyAnfTxzdHJvbmc+e2Zvcm1hdE1vbmV5KHBlcl9wZXJzb25fbGlhYmlsaXR5X2xpbWl0KX0ve2Zvcm1hdE1vbmV5KHBlcl9hY2NpZGVudF9saWFiaWxpdHlfbGltaXQpfTwvc3Ryb25nPlxuICAgICAgICB7JyAnfWFuZCBtYW55IGxlZ2FsIGZ1bmRlcnMgcmVseSBvbiB0aGlzIG51bWJlciBhYnNlbnQgYWN0dWFsIGtub3dsZWRnZSBvZiBwb2xpY3kgbGltaXRzLjwvcD5cbiAgICApO1xuICB9XG5cbiAgcmVuZGVyU3RhY2tpbmcgKCkge1xuICAgIGNvbnN0IHsgc3RhdGVNVkFUaHJlc2hvbGQgfSA9IHRoaXMucHJvcHM7XG4gICAgaWYgKHN0YXRlTVZBVGhyZXNob2xkLnN0YWNraW5nKSB7XG4gICAgICByZXR1cm47XG4gICAgfVxuICAgIHJldHVybiAoXG4gICAgICA8c3Bhbj5JZiB0aGUgcGxhaW50aWZmIGhhcyBhY2Nlc3MgdG8gVU0vVUlNIGNvdmVyYWdlLCBpdCA8c3Ryb25nPmNhbm5vdCBiZSBzdGFja2VkPC9zdHJvbmc+IG9uIHRoZSB0b3J0ZmVhc29yJiMzOTtzIHBvbGljeS48L3NwYW4+XG4gICAgKTtcbiAgfVxuXG4gIHJlbmRlclJlc291cmNlVVJMICgpIHtcbiAgICBjb25zdCB7IHN0YXRlTVZBVGhyZXNob2xkIH0gPSB0aGlzLnByb3BzO1xuICAgIHJldHVybiAoXG4gICAgICA8cD48YSB0YXJnZXQ9J19ibGFuaycgaHJlZj17c3RhdGVNVkFUaHJlc2hvbGQucmVzb3VyY2Vfd2Vic2l0ZX0+VmlldyBFeHRlcm5hbCBSZXNvdXJjZTwvYT48L3A+XG4gICAgKTtcbiAgfVxuXG4gIG5vUElQVGVtcGxhdGUgKCkge1xuICAgIHJldHVybiAoXG4gICAgICA8cD5UaGVyZSBpcyA8c3Ryb25nPm5vIFBJUDwvc3Ryb25nPiBpbiB0aGlzIHN0YXRlLjwvcD5cbiAgICApO1xuICB9XG5cbiAgb2ZmZXJlZFBJUFRlbXBsYXRlICgpIHtcbiAgICByZXR1cm4gKFxuICAgICAgPHA+PHN0cm9uZz5QSVAgaXMgb2ZmZXJlZDwvc3Ryb25nPiB0byBtb3RvcmlzdHMgaW4gdGhpcyB7dGhpcy5nZXRQSVBDb3ZlcmFnZSgpfTwvcD5cbiAgICApO1xuICB9XG5cbiAgbWFuZGF0b3J5UElQVGVtcGxhdGUgKCkge1xuICAgIHJldHVybiAoXG4gICAgICA8cD48c3Ryb25nPlBJUCBpcyBtYW5kYXRvcnk8L3N0cm9uZz4gaW4gdGhpcyB7dGhpcy5nZXRQSVBDb3ZlcmFnZSgpfTwvcD5cbiAgICApO1xuICB9XG5cbiAgcmVuZGVyVU1JbmZvcm1hdGlvbiAoKSB7XG4gICAgY29uc3QgeyB1bmluc3VyZWRfbW90b3Jpc3RfaW5mb3JtYXRpb24sIHN0YXRlLCB1aW1fcGVyX3BlcnNvbl9jb3ZlcmFnZSwgdWltX3Blcl9hY2NpZGVudF9jb3ZlcmFnZSB9ID0gdGhpcy5wcm9wcy5zdGF0ZU1WQVRocmVzaG9sZDtcbiAgICBpZiAodW5pbnN1cmVkX21vdG9yaXN0X2luZm9ybWF0aW9uID09PSAnTm90IFJlcXVpcmVkJykge1xuICAgICAgcmV0dXJuIChcbiAgICAgICAgPHA+VU0vVUlNIGlzIDxzdHJvbmc+bm90IHJlcXVpcmVkPC9zdHJvbmc+LiB7dGhpcy5yZW5kZXJTdGFja2luZygpfTwvcD5cbiAgICAgICk7XG4gICAgfVxuICAgIGVsc2UgaWYgKHVuaW5zdXJlZF9tb3RvcmlzdF9pbmZvcm1hdGlvbiA9PT0gJ1VNJykge1xuICAgICAgcmV0dXJuIChcbiAgICAgICAgPHA+PHN0cm9uZz57c3RhdGV9PC9zdHJvbmc+IHJlcXVpcmVzIDxzdHJvbmc+e2Zvcm1hdE1vbmV5KHVpbV9wZXJfcGVyc29uX2NvdmVyYWdlKX0ve2Zvcm1hdE1vbmV5KHVpbV9wZXJfYWNjaWRlbnRfY292ZXJhZ2UpfTwvc3Ryb25nPiBpbiBVTSBjb3ZlcmFnZS57dGhpcy5yZW5kZXJTdGFja2luZygpfTwvcD5cbiAgICAgICk7XG4gICAgfVxuICAgIHJldHVybiAoXG4gICAgICA8cD48c3Ryb25nPntzdGF0ZX08L3N0cm9uZz4gcmVxdWlyZXMgPHN0cm9uZz57Zm9ybWF0TW9uZXkodWltX3Blcl9wZXJzb25fY292ZXJhZ2UpfS97Zm9ybWF0TW9uZXkodWltX3Blcl9hY2NpZGVudF9jb3ZlcmFnZSl9PC9zdHJvbmc+IGluIFVNL1VJTSBjb3ZlcmFnZS57dGhpcy5yZW5kZXJTdGFja2luZygpfTwvcD5cbiAgICApO1xuICB9XG5cblxuICBnZXRQSVBDb3ZlcmFnZSAoKSB7XG4gICAgY29uc3QgeyBzdGF0ZU1WQVRocmVzaG9sZCB9ID0gdGhpcy5wcm9wc1xuICAgICAgLCB7IHBpcF9wZXJfcGVyc29uX2NvdmVyYWdlLCBwaXBfcGVyX2FjY2lkZW50X2NvdmVyYWdlLCBwaXBfbGltaXRlZF9ieSwgdW5saW1pdGVkX3BpcF9jb3ZlcmFnZSB9ID0gc3RhdGVNVkFUaHJlc2hvbGQ7XG4gICAgaWYgKHBpcF9wZXJfcGVyc29uX2NvdmVyYWdlICYmIHBpcF9wZXJfYWNjaWRlbnRfY292ZXJhZ2UpIHtcbiAgICAgIHJldHVybiAoXG4gICAgICAgIDxzcGFuPlxuICAgICAgICAgIHN0YXRlIGFuZCBwcm92aWRlcyB1cCB0byA8c3Ryb25nPntmb3JtYXRNb25leShwaXBfcGVyX3BlcnNvbl9jb3ZlcmFnZSl9PC9zdHJvbmc+IHBlciBwZXJzb24sXG4gICAgICAgICAgeycgJ308c3Ryb25nPntmb3JtYXRNb25leShwaXBfcGVyX2FjY2lkZW50X2NvdmVyYWdlKX08L3N0cm9uZz4gcGVyIGFjY2lkZW50IGluIG1lZGljYWwgY292ZXJhZ2UuPC9zcGFuPlxuICAgICAgKTtcbiAgICB9XG4gICAgZWxzZSBpZiAocGlwX3Blcl9wZXJzb25fY292ZXJhZ2UpIHtcbiAgICAgIGlmIChwaXBfbGltaXRlZF9ieSkge1xuICAgICAgICByZXR1cm4gKFxuICAgICAgICAgIDxzcGFuPnN0YXRlIGFuZCBwcm92aWRlcyB1cCB0byA8c3Ryb25nPntmb3JtYXRNb25leShwaXBfcGVyX3BlcnNvbl9jb3ZlcmFnZSl9PC9zdHJvbmc+IGluIG1lZGljYWwgY292ZXJhZ2Uge3BpcF9saW1pdGVkX2J5fS48L3NwYW4+XG4gICAgICAgICk7XG4gICAgICB9XG4gICAgICByZXR1cm4gKFxuICAgICAgICA8c3Bhbj5zdGF0ZSBhbmQgcHJvdmlkZXMgdXAgdG8gPHN0cm9uZz57Zm9ybWF0TW9uZXkocGlwX3Blcl9wZXJzb25fY292ZXJhZ2UpfTwvc3Ryb25nPiBpbiBtZWRpY2FsIGNvdmVyYWdlLjwvc3Bhbj5cbiAgICAgICk7XG4gICAgfVxuICAgIGVsc2UgaWYgKHVubGltaXRlZF9waXBfY292ZXJhZ2UpIHtcbiAgICAgIHJldHVybiAoXG4gICAgICAgICdzdGF0ZSBhbmQgcHJvdmlkZXMgdW5saW1pdGVkIGNvdmVyYWdlLidcbiAgICAgICk7XG4gICAgfVxuICAgIHJldHVybiAoXG4gICAgICAnc3RhdGUuJ1xuICAgICk7XG4gIH1cblxuXG4gIG9uZVBlcmNlbnRCYXJUZW1wbGF0ZSAoKSB7XG4gICAgY29uc3QgeyBzdGF0ZU1WQVRocmVzaG9sZCB9ID0gdGhpcy5wcm9wcztcbiAgICByZXR1cm4gKFxuICAgICAgPHA+PHN0cm9uZz57c3RhdGVNVkFUaHJlc2hvbGQuc3RhdGV9PC9zdHJvbmc+IHVzZXMgYSA8c3Ryb25nPjElIEJhcjwvc3Ryb25nPi4gSWYgdGhlIGluanVyZWQgcGFydHkgY2FycmllcyBhbnkgZmF1bHQgKGV2ZW4gMSUpLCBoZSBvciBzaGUgd2lsbCBiZSBiYXJyZWQgZnJvbSBhbnkgcmVjb3ZlcnkuPC9wPlxuICAgICk7XG4gIH1cblxuICBmaWZ0eVBlcmNlbnRCYXJUZW1wbGF0ZSAoKSB7XG4gICAgY29uc3QgeyBzdGF0ZU1WQVRocmVzaG9sZCB9ID0gdGhpcy5wcm9wcztcbiAgICByZXR1cm4gKFxuICAgICAgPHA+XG4gICAgICAgIDxzdHJvbmc+e3N0YXRlTVZBVGhyZXNob2xkLnN0YXRlfTwvc3Ryb25nPiB1c2VzIGEgPHN0cm9uZz41MCUgQmFyPC9zdHJvbmc+LiBSZWNvdmVyeSBpcyBvbmx5IHBvc3NpYmxlIGlmXG4gICAgICAgIHsnICd9dGhlIGluanVyZWQgcGFydHkgaXMgbGVzcyB0aGFuIDUwJSBhdCBmYXVsdC4gUmVjb3Zlcnkgd2lsbCBiZSBwcm9wb3J0aW9uYXRlbHkgcmVkdWNlZCBieSB0aGUgZGVncmVlIHRvXG4gICAgICAgIHsnICd9d2hpY2ggaGUgb3Igc2hlIGlzIGxpYWJsZS5cbiAgICAgIDwvcD5cbiAgICApO1xuICB9XG5cbiAgZmlmdHlPbmVQZXJjZW50QmFyVGVtcGxhdGUgKCkge1xuICAgIGNvbnN0IHsgc3RhdGVNVkFUaHJlc2hvbGQgfSA9IHRoaXMucHJvcHM7XG4gICAgcmV0dXJuIChcbiAgICAgIDxwPlxuICAgICAgICA8c3Ryb25nPntzdGF0ZU1WQVRocmVzaG9sZC5zdGF0ZX08L3N0cm9uZz4gaXMgYSA8c3Ryb25nPjUxJSBCYXI8L3N0cm9uZz4gc3RhdGUuIFJlY292ZXJ5IGlzIG9ubHkgcG9zc2libGVcbiAgICAgICAgeycgJ31pZiB0aGUgaW5qdXJlZCBwYXJ0eSBpcyBsZXNzIHRoYW4gNTElIGF0IGZhdWx0LiBSZWNvdmVyeSB3aWxsIGJlIHByb3BvcnRpb25hdGVseSByZWR1Y2VkIGJ5IHRoZSBkZWdyZWUgdG9cbiAgICAgICAgeycgJ313aGljaCBoZSBvciBzaGUgaXMgbGlhYmxlLlxuICAgICAgPC9wPlxuICAgICk7XG4gIH1cblxuICBub0JhclRlbXBsYXRlICgpIHtcbiAgICBjb25zdCB7IHN0YXRlTVZBVGhyZXNob2xkIH0gPSB0aGlzLnByb3BzO1xuICAgIHJldHVybiAoXG4gICAgICA8cD5cbiAgICAgICAgPHN0cm9uZz57c3RhdGVNVkFUaHJlc2hvbGQuc3RhdGV9PC9zdHJvbmc+IHVzZXMgYSA8c3Ryb25nPlB1cmUgQ29tcGFyYXRpdmUgRmF1bHQ8L3N0cm9uZz4gc3lzdGVtLiBJZiB0aGVcbiAgICAgICAgeycgJ31pbmp1cmVkIHBhcnR5IGlzIHBhcnRpYWxseSBhdCBmYXVsdCAoZXZlbiA5OSUpLCByZWNvdmVyeSBpcyBzdGlsbCBwb3NzaWJsZS4gUmVjb3Zlcnkgd2lsbCBiZVxuICAgICAgICB7JyAnfXByb3BvcnRpb25hdGVseSByZWR1Y2VkIGJ5IHRoZSBkZWdyZWUgdGhhdCB0aGUgY2xhaW1hbnQgaXMgZGVlbWVkIGxpYWJsZS5cbiAgICAgIDwvcD5cbiAgICApO1xuICB9XG5cbiAgc2xpZ2h0QmFyVGVtcGxhdGUgKCkge1xuICAgIGNvbnN0IHsgc3RhdGVNVkFUaHJlc2hvbGQgfSA9IHRoaXMucHJvcHM7XG4gICAgcmV0dXJuIChcbiAgICAgIDxwPlxuICAgICAgICA8c3Ryb25nPntzdGF0ZU1WQVRocmVzaG9sZC5zdGF0ZX08L3N0cm9uZz4gdXNlcyBhICYjMzQ7U2xpZ2h0JiMzNDsgQmFyLiBJZiB0aGUgaW5qdXJlZCBwYXJ0eSYjMzk7c1xuICAgICAgICB7JyAnfW5lZ2xpZ2VuY2UgaXMgbW9yZSB0aGFuICYjMzQ7c2xpZ2h0JiMzNDsgaW4gY29tcGFyaXNvbiB0byB0aGUgb3RoZXIgcGFydHkmIzM5O3MsIGhlIG9yIHNoZSB3aWxsIGJlXG4gICAgICAgIHsnICd9YmFycmVkIGZyb20gYW55IHJlY292ZXJ5XG4gICAgICA8L3A+XG4gICAgKTtcbiAgfVxuXG4gIG5vVGhyZXNob2xkVGVtcGxhdGUgKCkge1xuICAgIHJldHVybiAoXG4gICAgICA8cD5JZiBhbiBpbmRpdmlkdWFsIHJlY292ZXJzIHRocm91Z2ggUElQLCB0aGVyZSBpcyA8c3Ryb25nPm5vIHRocmVzaG9sZDwvc3Ryb25nPiBvbiBmaWxpbmcgYSBkYW1hZ2VzIGNsYWltIGFnYWluc3QgdGhlIHRvcnRmZWFzb3IuPC9wPlxuICAgICk7XG4gIH1cblxuICBjZXJ0YWluVGhyZXNob2xkVGVtcGxhdGUgKCkge1xuICAgIHJldHVybiAoXG4gICAgICA8cD5JbiB0aGlzIHN0YXRlIGFuIGluZGl2aWR1YWwgaXMgbm90IHBlcm1pdHRlZCB0byBmaWxlIGEgdG9ydCBhY3Rpb24gdW5sZXNzIGhpcyBvciBoZXIgZGFtYWdlcyByZWFjaCBhIGNlcnRhaW4gdGhyZXNob2xkLjwvcD5cbiAgICApO1xuICB9XG5cbiAgbm9GYXVsdFRocmVzaG9sZCAoKSB7XG4gICAgcmV0dXJuIChcbiAgICAgIDxwPlRoaXMgaXMgYSA8c3Ryb25nPk5vLUZhdWx0PC9zdHJvbmc+IHN0YXRlLCBidXQgdGhlcmUgaXMgPHN0cm9uZz5ubyB0aHJlc2hvbGQ8L3N0cm9uZz4gb24gZmlsaW5nIGEgZGFtYWdlcyBjbGFpbSBhZ2FpbnN0IHRoZSB0b3J0ZmVhc29yLjwvcD5cbiAgICApO1xuICB9XG5cbiAgcmVuZGVyICgpIHtcbiAgICByZXR1cm4gKFxuICAgICAgPFJvdz5cbiAgICAgICAgPEluZm9XZWxsLkxhYmVsPk1WQSBVTkRFUldSSVRJTkcgSU5TSUdIVDwvSW5mb1dlbGwuTGFiZWw+XG4gICAgICAgIDxJbmZvV2VsbC5WYWx1ZT5cbiAgICAgICAgICB7dGhpcy5yZW5kZXJDb21wYXJhdGl2ZU5lZ2xpZ2VuY2UoKX1cbiAgICAgICAgICB7dGhpcy5yZW5kZXJMaWFiaWxpdHlEYXRhKCl9XG4gICAgICAgICAge3RoaXMucmVuZGVyVU1JbmZvcm1hdGlvbigpfVxuICAgICAgICAgIHt0aGlzLnJlbmRlclBJUCgpfVxuICAgICAgICAgIHt0aGlzLnJlbmRlclBJUFJlc3RyaWN0aW9uKCl9XG4gICAgICAgICAge3RoaXMucmVuZGVyUmVzb3VyY2VVUkwoKX1cbiAgICAgICAgPC9JbmZvV2VsbC5WYWx1ZT5cbiAgICAgIDwvUm93PlxuICAgICk7XG4gIH1cblxuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIHN0YXRlTVZBVGhyZXNob2xkOiBQcm9wVHlwZXMub2JqZWN0LFxuICB9O1xufVxuXG5leHBvcnQgZGVmYXVsdCBNVkFVbmRlcndyaXRpbmdJbnNpZ2h0O1xuIl19